export default __webpack_public_path__ + "static/media/flag.f217653e.svg";